module.exports = __webpack_public_path__ + "img/resize-alt-reverse.c1529ff1.svg";